export const DEFAULT_MOBILE_HEADER = "default";

export const MOBILE_HEADER_IDS = ["default", "header2"] as const;

export type MobileHeaderId = (typeof MOBILE_HEADER_IDS)[number];

const HEADER_CACHE_PREFIX = "sky-mobile-header-v1:";

export const normalizeMobileHeaderId = (
  value?: string | null
): MobileHeaderId => {
  const id = String(value || "").trim();
  if (!id || id === "default") return DEFAULT_MOBILE_HEADER;
  if (id === "header2" || id === "alternate" || id === "new" || id === "mobile-2") {
    return "header2";
  }
  return DEFAULT_MOBILE_HEADER;
};

export const headerCacheKey = (hostname = window.location.hostname) =>
  `${HEADER_CACHE_PREFIX}${hostname}`;

export const readHeaderCache = (): { mobileHeader: MobileHeaderId } | null => {
  try {
    const raw = localStorage.getItem(headerCacheKey());
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return {
      mobileHeader: normalizeMobileHeaderId(parsed?.mobileHeader),
    };
  } catch {
    return null;
  }
};

export const writeHeaderCache = (mobileHeader: MobileHeaderId) => {
  try {
    localStorage.setItem(
      headerCacheKey(),
      JSON.stringify({ mobileHeader })
    );
  } catch {
    // ignore quota / private mode
  }
};
